import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_BLOCK_PREFIX, BLOCKLY_CARD_PREFIX, BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory, PROPERTIES_FOR_CUSTOM_OPTION_ITEM, PROPERTIES_FOR_STRING_JOIN_ITEM } from "../blocky-types.types";
import { GptChatModelTypeArr } from "@shared/index";
import { OVERLAY_PLACEMENT } from "./overlays.category";

export function BlocklyCategory_DEPRECATED(name: string = "Veraltete Blöcke", BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.DEPRECATED, name: name, contents: [] };
  BH.setCategoryContext(BLOCKLY_COLORS.DEPRECATED);

  cat.contents = [
    BH.label(name),
    // text_join: nativer Blockly-Block, Farbe nicht überschreibbar – aus Toolbox ausgeblendet, aber weiterhin registriert
    BH.withNested(
      BH._custom("STRING_JOINING", "@output:String\n🧵: {{parts:statement[@check=CHAINITEM]}}", "[{{parts}}].join('')", { colour: BLOCKLY_COLORS.CHAINS, nextStatement: 'CHAINITEM', connection: 'none' })
      , [{ forValue: "parts", isShadow: true, targetBlockType: 'STRING_JOINING_TXT' }]
    ),
    BH.withNested(
      BH._custom("STRING_JOINING_TXT", "🪢:{{text}}", "{{text}},", PROPERTIES_FOR_STRING_JOIN_ITEM),
      [{ forValue: "text", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }]
    ),
    BH.withNested(
      BH._custom("AI_GENERATED_TEXT", `@output:String\n KI-generierter Text:
      Model: {{model:dropdown=${GptChatModelTypeArr.join(",")}}}  | Temperatur: {{temp:number=0.7}} |  Websuche: {{webSearch:checkbox=false}}
      Prompt: {{prompt}}
`, "await RAGAI.AITEXT_OPENAI.chatCompletion({{prompt}}, '{{model}}', {{temp}}, {{webSearch}})", { colour: BLOCKLY_COLORS.MESSAGES_LIGHT, inputsInline: true }),
      [{ forValue: "prompt", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
    ),
    BH.withNested(
      BH.card("CARD_IMG_FROM_BLOCK", BLOCKLY_CARD_PREFIX.IMAGE + " Bild", "{{value[@check=IMAGE,URL]}}\nALT-Text:{{alt}}\nCSS-Class:{{css}}", "await RAGAI.CARDS.image({{value}},{{alt}},{{css}});"),
      [{ forValue: 'value', isShadow: false, targetBlockType: 'BLOCK_STACK_IMAGE' },
      { forValue: 'alt', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: 'Image Description' } },
      { forValue: 'css', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "my-theme" } }
      ]
    ),
    BH.withNested(
      BH.startBlock(
        "BOT_WELCOME_MESSAGE",
        "Start mit Nachricht, wenn noch kein Chatverlauf existiert: \nTyp: {{type:dropdown=KI-generiert|'generiert',statisch|'statisch'}}\nInhalt/Anweisung: {{value}}",
        "await RAGAI.WAITFOR.initialIdle(); if (RAGAI.INFO.messagesCount() === 0) {\nif ({{type}} === 'statisch') {\nawait RAGAI.MSG.botMessage({{value}});\n} else {\nawait RAGAI.MSG.prompt({{value}});\n}\n}"
      ),
      [{ forValue: 'value', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
    ),
    BH.withNested(
      BH.card(
        "AIIMAGE_GENERATE_IMAGE_IN_CARD",
        BLOCKLY_CARD_PREFIX.IMAGE,
        "AI Bild:{{description[@check=String]}}",
        `const res = await RAGAI.AIIMAGE_STABLEDIFFUSION.create({{description}});
const imgUrl = RAGAI.AIIMAGE_STABLEDIFFUSION.getImageUrl(res._id);
RAGAI.CARDS.image(window.location.origin + imgUrl);`
      ),
      [{ forValue: "description", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Strandkörbe am Meer" } }]
    ),
    BH.withNested(
      BH._custom(
        "AIIMAGE_GENERATE_IMAGE_IN_CARD_NEW",
        "@output:URL\nAI generiertes Bild\nModell: {{model:dropdown=Stable Diffusion|RAGAI.AIIMAGE_STABLEDIFFUSION,OpenAI|RAGAI.AIIMAGE_OPENAI}}\nPrompt: {{prompt[@check=String]}}",
        "(await (async () => { const imageUrl = await {{model}}.getImageUrl((await {{model}}.create({{prompt}}))._id); return imageUrl && imageUrl.startsWith('http') ? imageUrl : window.location.origin + imageUrl; })())",

        { colour: BLOCKLY_COLORS.CARDS, inputsInline: true }
      ),
      [{ forValue: "prompt", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Strandkörbe am Meer" } }]
    ),
    BH.withNested(BH.message("SEND_PROMPT_TXT", "Prompt Senden und Bot-Antwort anzeigen:{{value}}", "await RAGAI.MSG.prompt({{value}});"), [{ forValue: 'value', isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }]),
    BH.withNested(
      BH.card("CARD_BUTTONS", BLOCKLY_CARD_PREFIX.BUTTONS + " Buttons", "{{buttons:statement[@check=BUTTON]}}CSS-Class:{{?css}}", "await RAGAI.CARDS.buttons([{{buttons}}],{{css}});"),
      []
    ),
    { kind: 'block', type: 'RAGAI_BUTTON' } as any,
    { kind: 'block', type: 'RAGAI_BUTTON_TEXT' } as any,
    { kind: 'block', type: 'RAGAI_BUTTON_OUTPUT' } as any,
    { kind: 'block', type: 'RAGAI_BUTTON_OUTPUT_IF' } as any,
    { kind: 'block', type: 'RAGAI_BUTTON_TEXT_2' } as any,
    { kind: 'block', type: 'WAITFOR_NEXTIDLE' } as any,
    { kind: 'block', type: 'WAITFOR_INITIDLE' } as any,
    { kind: 'block', type: 'WAITFOR_SCORMINITED' } as any,
    { kind: 'block', type: 'WAITFOR_INITVARS' } as any,
    { kind: 'block', type: 'WAITFOR_EVENT' } as any,
    { kind: 'block', type: 'WAITFOR_SECONDS' } as any,
    { kind: 'block', type: 'WAITFOR_MINUTES' } as any,
    { kind: 'block', type: 'SKILL_ENABLECHILD' } as any,
    { kind: 'block', type: 'SKILL_DISABLECHILD' } as any,
    BH.actionDropdown("BOT_CONTROLS", "Bot", [
      ["neu starten", "await RAGAI.restartBot();"],
      ["cancel()", "await RAGAI.cancel();"]
    ]),
    BH.actionDropdown("OVERLAY_ACTIONS", "Overlay", [
      ["close()", "await RAGAI.OVERLAY.close();"]
    ]),
    // FIX FOR DEPRECATION: Diese Blöcke wurden teilweise durch flexiblere Varianten ersetzt, werden aber hier weiterhin registriert, damit bestehende Workspaces nicht brechen. Sie sollten in neuen Projekten nicht mehr verwendet werden.
    BH.actionDropdown("STAGE_ACTIONS", "Stage", [
      ["Next()", "await RAGAI.STAGE.next();"],
      ["Prev()", "await RAGAI.STAGE.prev();"],
      ["Restore()", "await RAGAI.STAGE.restore();"]
    ]),
    {
      ...BH._custom("SKILL_FOR_NEXT_RUN", "Diese Skills für die Nächste Bot-Antwort erzwingen:\n {{skills:statement[@check=CHAINITEM]}}", "await RAGAI.SKILL.skillsForNextRun([{{skills}}]);", { colour: BLOCKLY_COLORS.ACTIONS, nextStatement: 'CHAINITEM' }),
      inputs: {
        skills: {
          block: {
            type: 'SKILL_JOINING',
            inputs: {
              skill: {
                shadow: {
                  type: 'BLOCK_STACK_SKILL',
                  fields: {}
                }
              }
            }
          }
        }
      }
    } as any
  ];

  // Nur registrieren für Abwärtskompatibilität
  BH.withNested(
    BH._custom("SKILL_JOINING", "🪢:{{skill}}", "{{skill}},", PROPERTIES_FOR_STRING_JOIN_ITEM),
    [{ forValue: "skill", isShadow: true, targetBlockType: 'BLOCK_STACK_SKILL' }]
  );

  // EVENTS_ON: alter Block, nur registriert für bestehende Workspaces
  BH.eventOn("EVENTS_ON", "bei Ereignis: {{eventName[@check=EVENT]}}\nEreignis-ID: {{eventId}}\n{{action:statement[@check=ACTION]}} {{callonce:checkbox}} Einmalig ausführen", `
    RAGAI.VARIABLES[{{eventId}}] = RAGAI.EVENTS.on({{eventName}},
     async function(eventName, eventData){
     {{action}}
      if({{callonce}}){
        RAGAI.EVENTS.off(RAGAI.VARIABLES[{{eventId}}]);
        delete RAGAI.VARIABLES[{{eventId}}];
       }
      });
      `, { colour: BLOCKLY_COLORS.EVENTS, inputsInline: true });

  // Benachrichtigungen (toastr) – veraltet, Blöcke werden anderswo registriert
  cat.contents.push(
    BH.label("Benachrichtigungen (veraltet)"),
    { kind: 'block', type: 'toastr_SUCCESS' } as any,
    { kind: 'block', type: 'toastr_ERROR' } as any,
    { kind: 'block', type: 'toastr_INFO' } as any,
    { kind: 'block', type: 'toastr_WARNING' } as any,
    { kind: 'block', type: 'toastr_options' } as any,
  );

  // Wenn-Dann – veraltet, Blöcke werden anderswo registriert
  cat.contents.push(
    BH.label("Wenn-Dann (veraltet)"),
    { kind: 'block', type: 'IFTHEN_COUNTER' } as any,
    { kind: 'block', type: 'GLOBAL_VAR' } as any,
  );

  // Event-Dropdowns – veraltet
  cat.contents.push(
    BH.label("Event-Dropdowns (veraltet)"),
    { kind: 'block', type: 'EVENT_ALL' } as any,
    { kind: 'block', type: 'EVENT_ALL_RAW' } as any,
    { kind: 'block', type: 'EVENT_TRIGGER' } as any,
    { kind: 'block', type: 'AITEXT_OPENAI_CHATCOMPLESION' } as any,
    { kind: 'block', type: 'AITEXT_OPENAI_CHATCOMPLETIONJSON' } as any,
    { kind: 'block', type: 'BOT_BYPASS_THREAD' } as any,
    { kind: 'block', type: 'OVERLAY_UPLOAD_IMAGE_ANALYSE_WITH_IMAGE' } as any,
  );

  // Upload-Blöcke – veraltet
  cat.contents.push(
    BH.label("Upload (veraltet)"),
    BH.withNested(
      BH.overlay(
        "OVERLAY_UPLOAD_TXT_EASY",
        "Upload:\nTitel:{{text}}\nHinweis:{{instruktion}}\n" + OVERLAY_PLACEMENT,
        "await RAGAI.OVERLAY.setPlacement({{placement}});\n await RAGAI.OVERLAY.uploadFile({{text}},{{instruktion}},async function(fileContent,fileName,fileType){ await RAGAI.CARDS.html('<i class=\"ri-file-2-fill\"> </i> '+fileName);\nawait RAGAI.MSG.userBypass(fileContent);\n await RAGAI.OVERLAY.close(); });"
      ),
      [
        {
          forValue: 'instruktion',
          isShadow: false,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "Datei hierher ziehen (.txt oder textbasiert)" }
        },
        {
          forValue: 'text',
          isShadow: false,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "Datei hochladen" }
        }
      ]
    ),
  );

  // Button mit onClick-Statement – veraltet
  cat.contents.push(
    BH.withNested(
      BH.button("RAGAI_BUTTON_2", "{{text}}\n bei klick: {{aktion:statement[@check=ACTION,OVERLAY]}}", `
      {text:{{text}},
      onClick: async function(){
      RAGAI.EVENTS.trigger("RAGAI.BUTTON.CLICK", {text: {{text}}});
      {{aktion}}
      }},`)
      , [{ forValue: 'text', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Button Name" } }]
    ),
  );

  // Stage-Buttons – veraltet
  cat.contents.push(
    BH.label("Stage (veraltet)"),
    BH.card("STAGE_LSITBTN", "Stage: Auswahl", " im Chatverlauf anzeigen", "await RAGAI.CARDS.stageListButtons();"),
  );

  // Stack-Blöcke (einzeln) – veraltet, ersetzt durch BLOCK_STACK
  cat.contents.push(
    BH.label("Stack-Blöcke (veraltet)"),
    { kind: 'block', type: 'BLOCK_STACK_WEBHOOK' } as any,
    { kind: 'block', type: 'BLOCK_STACK_DATABASE' } as any,
    { kind: 'block', type: 'BLOCK_STACK_WENNDANN' } as any,
    { kind: 'block', type: 'BLOCK_STACK_ONLINESOURCE' } as any,
    { kind: 'block', type: 'BLOCK_STACK_OFFLINEWEBSITE' } as any,
    { kind: 'block', type: 'BLOCK_STACK_FUSIONVIEW' } as any,
    { kind: 'block', type: 'BLOCK_STACK_PROJECTSECRET' } as any,
  );

  // Datenspeicher-Blöcke – veraltet, ersetzt durch V2
  cat.contents.push(
    BH.label("Datenspeicher (veraltet)"),
    BH.ragAi("KEYVAL_SET", "KEYVAL.set({{key}}, {{value}}, {{group}})", " await RAGAI.KEYVAL.set({{key}}, {{value}},{{group}});"),
    BH.ragAi("KEYVAL_UNIQUE", "KEYVAL.unique({{key}}, {{value}}, {{group}})", " await RAGAI.KEYVAL.unique({{key}}, {{value}},{{group}});"),
    BH.ragAi("KEYVAL_GET", "@output:String\nKEYVAL.get({{key}},{{group:text=Collection}})", "await RAGAI.KEYVAL.get({{key}},{{group}})"),
    BH.ragAi("KEYVAL_GET_COLLECTION_VALUES", "@output:String\nKEYVAL.getCollectionValues({{group:text=Collection}})", "(await RAGAI.KEYVAL.getByType({{group}})).map(e => e.value)"),
    BH.ragAi("KEYVAL_GET_COLLECTION_TEXT", "@output:String\nKEYVAL.getCollectionText({{group:text=Collection}})", "(await RAGAI.KEYVAL.getByType({{group}})).map(e => e.value).join('\\n')"),
    BH.ragAi("PROJECTKEYVAL_SET", "PROJECTKEYVAL.set({{key}}, {{value}}, {{group}})", " await RAGAI.PROJECTKEYVAL.set({{key}}, {{value}},{{group}});"),
    BH.ragAi("PROJECTKEYVAL_UNIQUE", "PROJECTKEYVAL.unique({{key}}, {{value}}, {{group}})", " await RAGAI.PROJECTKEYVAL.unique({{key}}, {{value}},{{group}});"),
    BH.ragAi("PROJECTKEYVAL_GET", "@output:String\nPROJECTKEYVAL.get({{key}},{{group:text=Collection}})", "await RAGAI.PROJECTKEYVAL.get({{key}},{{group}})"),
    BH.ragAi("PROJECTKEYVAL_GET_COLLECTION_VALUES", "@output:String\nPROJECTKEYVAL.getCollectionValues({{group:text=Collection}})", "(await RAGAI.PROJECTKEYVAL.getByType({{group}})).map(e => e.value)"),
    BH.ragAi("PROJECTKEYVAL_GET_COLLECTION_TEXT", "@output:String\nPROJECTKEYVAL.getCollectionText({{group:text=Collection}})", "(await RAGAI.PROJECTKEYVAL.getByType({{group}})).map(e => e.value).join('\\n')"),
  );

  // PDF-Download – veraltet
  cat.contents.push(
    BH.label("Download (veraltet)"),
    BH.withNested(
      BH.ragAi("RAGAI_DOWNLOAD_TEMPLATE", "DOWNLOAD.downloadFilledPDFTemplate({{skillId}},{{fileName}})", "await RAGAI.DOWNLOAD.downloadFilledPDFTemplate({{skillId}},{{fileName}});"),
      [
        { forValue: "skillId", isShadow: true, targetBlockType: 'BLOCK_STACK_DOCUMENT' },
        { forValue: "fileName", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "download.pdf" } }
      ]
    ),
  );

  // Mail-Blöcke – veraltet
  cat.contents.push(
    BH.label("Mail (veraltet)"),
    BH.withNested(
      BH._custom("MAIL_SEND_WEBHOOK", "📤 Mail per:\n {{webhook}}  {{envelope[@check=MAILENVELOPE]}} senden", " await RAGAI.MAIL.webhook({{webhook}}, {{envelope}});", { colour: BLOCKLY_COLORS.MAIL }),
      [{ forValue: "webhook", isShadow: true, targetBlockType: 'BLOCK_STACK_WEBHOOK' }]
    ),
    BH.withNested(
      BH._custom("MAIL_ENVELOPE", "@output:MAILENVELOPE\n" + BLOCKLY_BLOCK_PREFIX.MAIL + "Mail\n An: {{to}} Betreff:{{subject}} Inhalt:{{body}}", "await RAGAI.MAIL.getEnvelope({{to}}, {{subject}}, {{body}})", { colour: BLOCKLY_COLORS.MAIL }),
      [
        {
          forValue: 'to',
          isShadow: false,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "example@example.com" }
        },
        {
          forValue: 'subject',
          isShadow: false,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "Test-Email" }
        },
        {
          forValue: 'body',
          isShadow: false,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "Dies ist ein Test" }
        }
      ]
    ),
  );

  // Webhook-Optionen – veraltet
  cat.contents.push(
    BH.label("Webhook-Optionen (veraltet)"),
    BH.withNested(
      BH._custom(
        `webhook_options`,
        `@output:WH_OPTION
        ⚙️
        value1 {{ value1 }}
        value2 {{ value2 }}
        value3 {{ value3 }}
        `,
        `{
  value1: {{ value1 }},
  value2: {{ value2 }},
  value3: {{ value3 }}
}`,
        { colour: BLOCKLY_COLORS.RAGAI_DARK, inputsInline: true }
      ),
      [
        { forValue: "value1", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
        { forValue: "value2", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
        { forValue: "value3", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }
      ]
    ),
    BH.withNested(
      BH._custom("webhook_custom_options", "@output:WH_OPTION\n⚙️: {{parts:statement}}", "JSON.parse('{' + [{{parts}}].join(', ') + '}')", { colour: BLOCKLY_COLORS.RAGAI_DARK, connection: 'none' }),
      [{ forValue: "parts", isShadow: true, targetBlockType: 'custom_option_item' }]
    ),
    BH.withNested(
      BH._custom("custom_option_item", "Key: {{ key }}, Value: {{ value }}", "'{{key}}: {{value}}', ", PROPERTIES_FOR_CUSTOM_OPTION_ITEM),
      [
        { forValue: "key", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
        { forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }
      ]
    ),
  );

  // Bedingungen – veraltet
  cat.contents.push(
    BH.label("Bedingungen (veraltet)"),
    BH._custom("RAG_IF_2", "(DEFEKT!) prüfe ob {{a}} dann tu {{actions:statement}}", "({{a}} ?  {{actions}} : '' )", { inputsInline: true }),
  );

  // Overlays – veraltet
  cat.contents.push(
    BH.label("Overlays (veraltet)"),
    { kind: 'block', type: 'OVERLAY_PROMPT' } as any,
  );

  BH.patchAllDeprecatedBlockColours();
  BH.clearCategoryContext();
  return cat;
}
